import nonVSSpacesBase from "./nonVSSpacesBase";
import { SpaceConfig } from "./spaceConfig";
import { SpaceId } from "./spaceIds";
import { UnknownSlugWorkaround } from "./spacesBase";

const spaceVSMac: SpaceConfig = {
    ...nonVSSpacesBase,
    id: SpaceId.VSMac,
    displayName: "Visual Studio for Mac",
    slug: UnknownSlugWorkaround,
    spaceTag: { type: "tag", value: "visual-studio-for-mac" },
    reportProblemConfig: {
        ...nonVSSpacesBase.reportProblemConfig,
        reportingNotAllowed: true,
        feedbackNotAllowedHtml: "We are no longer accepting problem reports for Visual Studio for Mac. As of August 31st, 2024, Visual Studio for Mac has been retired, in accordance with Microsoft's Modern Lifecycle Policy. To learn more about the retirement and for alternate options,<a href='https://learn.microsoft.com/en-us/visualstudio/releases/2022/what-happened-to-vs-for-mac' target='_blank'>Visual Studio for Mac Retirement Announcement</a> visit the article."
    },
    reportSuggestionConfig: {
        ...nonVSSpacesBase.reportSuggestionConfig,
        reportingNotAllowed: true,
        feedbackNotAllowedHtml: "We are no longer accepting feature suggestions for Visual Studio for Mac. As of August 31st, 2024, Visual Studio for Mac has been retired, in accordance with Microsoft's Modern Lifecycle Policy. To learn more about the retirement and for alternate options,<a href='https://learn.microsoft.com/en-us/visualstudio/releases/2022/what-happened-to-vs-for-mac' target='_blank'>Visual Studio for Mac Retirement Announcement</a> visit the article."
    }
};

export default spaceVSMac;
